import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/',
)({
    beforeLoad: ({ params, search }) => {
        throw redirect({
            to: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/information',
            params,
            search,
        });
    },
});
